<style scoped>

</style>
<template>
    <!--/ Section Testimonials Star /-->
    <div class="testimonials paralax-mf bg-image" style="background-image: url(images/overlay-bg.webp)">
        <div class="overlay-mf"></div>
        <div class="container">
        <div class="row">
            <div class="col-md-12">
            <div id="testimonial-mf" class="owl-carousel owl-theme">
                <div class="testimonial-box">
                <div class="author-test">
                    <img src="/images/user.webp" alt="" class="rounded-circle b-shadow-a">
                    <span class="author">Ítalo Ramalho</span>
                </div>
                <div class="content-test">
                    <p class="description lead">
                    Ficou Ótimo Brother! Brigadão Mesmo!
                    </p>
                    <span class="comit"><i class="fa fa-quote-right"></i></span>
                </div>
                </div>
                <div class="testimonial-box">
                <div class="author-test">
                    <img src="/images/user.webp" alt="" class="rounded-circle b-shadow-a">
                    <span class="author">Víctor Andrade</span>
                </div>
                <div class="content-test">
                    <p class="description lead">
                    Espetão, o serviço que você fez lá para o meu sogro ficou TOP viu.
                    </p>
                    <span class="comit"><i class="fa fa-quote-right"></i></span>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>